<mat-dialog-content>
  <h2 class="flex-row break-line">
    {{ 'label.copy_sample_findings' | translate }}
  </h2>

  <div
    class="analysts-container"
    *ngIf="{
      analysts: data.availableAnalysts | async,
      currUser: data.currUser
    } as state"
  >
    <div>
      <h5 style="margin-bottom: 10px; margin-top: 20px">
        {{ 'title.users' | translate }}
      </h5>

      <mat-radio-group [(ngModel)]="selectedAnalyst">
        <mat-radio-button [value]="state.currUser" class="analyst-radio">
          {{ 'core.me' | translate }}
        </mat-radio-button>
        <ng-container *ngFor="let analyst of state.analysts">
          <mat-radio-button *ngIf="analyst.type === 'user'" [value]="analyst" class="analyst-radio">
            {{ analyst.id === state.currUser.id ? ('core.me' | translate) : analyst.name }}
          </mat-radio-button>
        </ng-container>
      </mat-radio-group>
    </div>

    <div *ngIf="availableAnalysts(state.analysts, 'algorithm')">
      <h5 style="margin-bottom: 10px; margin-top: 20px">
        {{ 'title.ai_models' | translate }}
      </h5>
      <p *ngIf="data.aiAnalysisInProgressWarning" class="ai-analysis-in-progress-hint" role="status">
        <i class="ri-error-warning-fill" aria-hidden="true"></i>
        <span>{{ 'info.micro_ai_analysis_in_progress' | translate }}</span>
      </p>
      <mat-radio-group [(ngModel)]="selectedAnalyst">
        <ng-container *ngFor="let analyst of state.analysts">
          <mat-radio-button
            *ngIf="analyst.type !== 'user'"
            [value]="analyst"
            class="analyst-radio"
          >
            {{ analyst.name }}
          </mat-radio-button>
        </ng-container>
      </mat-radio-group>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="custom-dialog-actions justify-content-around">
  <button
    #btnCancel
    data-cy="dialog-button-cancel"
    mat-dialog-close
    class="btn btn-flat-primary"
    focused
    (click)="cancel()"
  >
    {{ 'button.cancel' | translate }}
  </button>
  <button
    #btnAccept
    data-cy="dialog-button-accept"
    class="btn btn-primary"
    (click)="confirm()"
  >
    {{ 'button.accept' | translate }}
  </button>
</mat-dialog-actions>
